import { render, staticRenderFns } from "./VersionCoin.vue?vue&type=template&id=18519c4b&scoped=true"
import script from "./VersionCoin.vue?vue&type=script&lang=js"
export * from "./VersionCoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18519c4b",
  null
  
)

export default component.exports